import moment from 'moment';
export function isValidEstadoLegajo(estadoLegajo) {
  const estadoLegajoMinuscula = estadoLegajo.toLowerCase();
  const opcionesValidas = [
    'otorgado',
    'aprobado',
    'incobrable',
    'normal',
    'precalificación',
    'calificación',
    'análisis',
    'requerimiento',
    'desistido',
    'caido',
    'refinanciado',
    'cerrado',
    'rechazado',
    'baja',
    'análisis técnico',
    'análisis legal',
    'análisis de garantía',
    'inadecuado',
    'problemas',
    'alto riesgo',
    'cancelado',
  ];
  return opcionesValidas.includes(estadoLegajoMinuscula);
}

export function isValidTipo(tipo) {
  const opcionesValidas = ['Física', 'Jurídica'];
  return opcionesValidas.includes(tipo);
}

export function isValidCUIT(cuit) {
  // Elimina caracteres no numéricos
  cuit = cuit.toString().replace(/\D/g, '');

  // Verifica la longitud
  if (cuit.length !== 11) return false;

  // Algoritmo de verificación
  const multipliers = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
  let sum = 0;
  for (let i = 0; i < 10; i++) {
    sum += parseInt(cuit[i]) * multipliers[i];
  }
  const verifierDigit = 11 - (sum % 11);
  const calculatedVerifier = verifierDigit === 11 ? 0 : verifierDigit;

  return parseInt(cuit[10]) === calculatedVerifier;
}

export function isValidSectorProductivo(sectorProductivo) {
  const sectorProductivoMinuscula = sectorProductivo.toLowerCase();

  const opcionesValidas = [
    'vitivinícola',
    'administración',
    'tecnológico',
    'agroindustrial',
    'general',
    'financiero',
    'deportivo',
    'inmobiliario',
    'emprendedor',
    'agrícola y/o vitivinícola',
    'audiovisual',
    'turismo y hotelería',
    'educación',
  ];
  return opcionesValidas.includes(sectorProductivoMinuscula);
}

export function isValidEmail(email) {
  // Validación de email utilizando una expresión regular
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
}

export function isValidGarantia(garantia) {
  const garantiaMinuscula = String(garantia == null ? '' : garantia)
    .trim()
    .toLowerCase();
  const opcionesValidas = [
    'personal',
    'pagaré',
    'fianza',
    'hipotecaria',
    'prenda',
    'cuyo aval',
  ];
  return opcionesValidas.includes(garantiaMinuscula);
}

export function isValidFechas(fechaInicio) {
  if (!fechaInicio || fechaInicio.trim() === '') {
    return false;
  }

  const fechaInicioMoment = moment(fechaInicio, 'DD/MM/YYYY'); //Formato DD/MM/YYYY

  return fechaInicioMoment.isValid();
}

export function isValidFechasDesembolso(fechaDesembolso) {
  if (!fechaDesembolso || fechaDesembolso.trim() === '') {
    return true; // Una fecha vacía se considera válida
  }

  const fechaDesembolsoMoment = moment(fechaDesembolso, 'DD/MM/YYYY'); //Formato DD/MM/YYYY

  return fechaDesembolsoMoment;
}

export function isValidPagos(pagos) {
  const pagosMinuscula = pagos.toLowerCase();
  const opcionesValidas = [
    'mensual',
    'bimestral',
    'semestral',
    'trimestral',
    'anual',
  ];
  return opcionesValidas.includes(pagosMinuscula);
}

export function isValidCBU(cbu) {
  cbu = cbu.toString().replace(/\D/g, '');
  return cbu.length === 22 && !isNaN(parseInt(cbu));
}
export function isValidLocalidad(valorExcel, localidades) {
  if (!valorExcel || !localidades) {
    return false;
  }
  const valorLimpiado = valorExcel.toString().trim().toLowerCase();
  return localidades.some(
    (l) => l.localidad.toString().trim().toLowerCase() === valorLimpiado
  );
}